<template>
  <div class="mapRemindArea">
    <div class="reminderNameTitle">
      <i
        class="iconfont icon-guanbi2"
        style="color: red"
        @click.stop="closeReminder"
      ></i>
    </div>
    <div class="reminderDetail" v-if="pointData">
      <div class="reminderDetailItem">
        <span>负责人： {{ pointData.contactName }}</span>
      </div>
      <div class="reminderDetailItem">
        <span>电话： {{ pointData.contactPhone }}</span>
      </div>
      <div class="reminderDetailItem">
        <span>楼栋数量： {{ pointData.buildNum }}</span>
      </div>
      <div class="reminderDetailItem">
        <span
          >所属部门：
          <span v-for="(item, index) in pointData.deptList" :key="index">{{
            item.name
          }}</span></span
        >
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, watchEffect } from "vue";
import deviceIcon from "@/utils/deviceIcon";
export default defineComponent({
  name: "mapRemindArea",
  components: {},
  props: {
    pointInfo: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, context) {
    const data = reactive({
      // pointData: {
      //   contactName: "--",
      //   contactPhone: "--",
      //   buildNum: "--",
      //   deptList: [{ name: "--" }],
      // },
      pointData: null,
    });
    const refData = toRefs(data);
    watchEffect(() => {
      data.pointData = props.pointInfo;
    });

    const closeReminder = () => {
      context.emit("closeReminder");
    };
    return {
      ...refData,
      closeReminder,
    };
  },
});
</script>
<style lang="scss" scoped>
.mapRemindArea {
  width: 160px;
  height: 150px;
  background: rgba(8, 13, 38, 0.8);
  color: #14d1b3;
  background-size: 100% 100%;
  padding: 10px;
  font-size: 14px;
  border-radius: 5px;
  overflow: auto;
  pointer-events: auto;
  .reminderNameTitle {
    width: 100%;
    @include flex-row-e-c;
    pointer-events: auto;
    i {
      cursor: pointer;
    }
  }

  .reminderDetail {
    width: 100%;
    height: 80%;
    overflow: auto;
    margin-bottom: 8px;

    .reminderDetailItem {
      margin: 6px 0;
      display: flex;
      cursor: pointer;
      img {
        width: 16px;
        margin-right: 16px;
      }
      span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  & ::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border: 10px solid;
    border-color: transparent;
    border-top-color: rgba(8, 13, 38, 0.8);
    top: 100%;
    left: 50%;
    margin-left: -10px;
  }
}
</style>
